import { render, staticRenderFns } from "./SubmissionError.vue?vue&type=template&id=667e1139&"
import script from "./SubmissionError.vue?vue&type=script&lang=js&"
export * from "./SubmissionError.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports